import Nav from "@/components/Header/Nav/Nav.tsx";
import Header from "@/components/Header/Header.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import ReviewSection from "@/components/ReviewSection/ReviewSection";
import ScrollingText from "@/components/ScrollingText";
import GridComponent from "@/components/GridComponent/GridComponent";
import OpenMenuBlock from "@/components/OpenMenuBlock/OpenMenuBlock";
import ServiceBlock from "@/components/ServiceBlock/ServiceBlock";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { Helmet } from "react-helmet";

interface SliderImage {
  src1920: string;
  src1440: string;
  src768: string;
  src320: string;
  alt: string;
  imageType: "full" | "partial";
}

const headerSlider: SliderImage[] = [
  {
    src1920: "/images/Home/slide1_1920.png",
    src1440: "/images/Home/slide1_1440.png",
    src768: "/images/Home/slide1_768.png",
    src320: "/images/Home/slide1_320.png",
    alt: "Slide 1",
    imageType: "partial",
  },
  {
    src1920: "/images/Home/slide2_1920.png",
    src1440: "/images/Home/slide2_1440.png",
    src768: "/images/Home/slide2_768.png",
    src320: "/images/Home/slide2_320.png",
    alt: "Slide 2",
    imageType: "partial",
  },
  {
    src1920: "/images/Home/slide3_1920.png",
    src1440: "/images/Home/slide3_1440.png",
    src768: "/images/Home/slide3_768.png",
    src320: "/images/Home/slide3_320.png",
    alt: "Slide 3",
    imageType: "partial",
  },
];

const Home = () => {
  const { t } = useTranslation("pages");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Отримуємо дані з перекладів
  const gridItems = t("home.grid.items", { returnObjects: true }) as Array<{
    title: string;
    description: string;
  }>;

  const gridData = [
    {
      icon: "/images/Grid/superman-ico.svg",
      title: gridItems[0].title,
      description: gridItems[0].description,
    },
    {
      icon: "/images/Grid/graph-ico.svg",
      title: gridItems[1].title,
      description: gridItems[1].description,
    },
    {
      icon: "/images/Grid/chckcar-ico.svg",
      title: gridItems[2].title,
      description: gridItems[2].description,
    },
    {
      icon: "/images/Grid/cert-ico.svg",
      title: gridItems[3].title,
      description: gridItems[3].description,
    },
    {
      icon: "/images/Grid/garant-ico.svg",
      title: gridItems[4].title,
      description: gridItems[4].description,
    },
    {
      icon: "/images/Grid/target-ico.svg",
      title: gridItems[5].title,
      description: gridItems[5].description,
    },
  ];

  const schemaOrgData = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    name: "HIXA Autoservice",
    url: "https://hixa.eu",
    logo: "https://hixa.eu/logo.png",
    image: "https://hixa.eu/logo.png",
    description:
      "Spezialist für Mechatronik-Überholung, DSG- und Powershift-Getriebereparatur, Diagnose und professionellen Autoservice in Berlin.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Neukirchstraße 74",
      addressLocality: "Berlin",
      postalCode: "13089",
      addressCountry: "DE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 52.5708,
      longitude: 13.4613,
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: "+493052015191",
      email: "info@hixa.eu",
      availableLanguage: ["de", "en", "ru", "uk"],
    },
    openingHours: ["Mo-Fr 08:00-17:00"],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      bestRating: "5",
      ratingCount: "127",
    },
    serviceOffered: [
      {
        "@type": "Service",
        name: "Mechatronik-Reparatur / Wiederaufbereitung",
        description:
          "Überholung und vollständige Instandsetzung von DSG-Mechatroniken.",
      },
      {
        "@type": "Service",
        name: "DSG-Getriebereparatur",
        description: "Reparatur und Überholung von DSG-Getrieben.",
      },
      {
        "@type": "Service",
        name: "Powershift-Getriebeservice",
        description:
          "Reparatur von Ford Powershift und anderen Doppelkupplungsgetrieben.",
      },
      {
        "@type": "Service",
        name: "Achsvermessung",
        description: "Präzise Spur- und Sturzeinstellung.",
      },
      {
        "@type": "Service",
        name: "Elektronische Fehlerdiagnose",
        description: "Fahrzeugdiagnose mit vollständigem Fehlerprotokoll.",
      },
      {
        "@type": "Service",
        name: "Öl- und Filterservice",
        description: "Wechsel von Motor- und DSG-Öl sowie Filtern.",
      },
      {
        "@type": "Service",
        name: "Fahrwerks- und Bremsenservice",
        description: "Reparatur von Fahrwerksteilen und Bremsanlagen.",
      },
    ],
    sameAs: [
      "https://www.facebook.com/hixa.eu",
      "https://www.instagram.com/hixa.eu",
    ],
  };

  return (
    <div>
      <Helmet>
        <title>{t("home.meta.title")}</title>
        <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgData)}
        </script>
      </Helmet>

      <Nav></Nav>
      <Header images={headerSlider}></Header>
      <ScrollingText></ScrollingText>
      <GridComponent
        title={t("home.grid.title")}
        items={gridData}
      ></GridComponent>
      <ServiceBlock></ServiceBlock>
      <OpenMenuBlock></OpenMenuBlock>
      <ReviewSection></ReviewSection>
      <Footer></Footer>
      <CookiePopupButton></CookiePopupButton>
    </div>
  );
};

export default Home;
